module.exports = __webpack_public_path__ + "static/media/lalamove.c6906d14.webp";